export default __webpack_public_path__ + "static/media/mover.9c8cab48.svg";